module.exports = __webpack_public_path__ + "static/media/starfighter.61888392.svg";